/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import { AxiosRequestConfig } from "axios";
import { SKIP_MESSAGE_SNACKBAR } from "../../constants/message";

//custom libraries
import { METHOD } from "../../constants/requests";
import { useRestService } from "./use-rest-service";

export const useStoresHandler = () => {
  const { executeRequest } = useRestService();

  const getStoresByTenant = () => {
    const requestOptions: AxiosRequestConfig | any = {
      method: METHOD.GET,
      url: "/stores/by-tenant",
      [SKIP_MESSAGE_SNACKBAR]: true,
    };

    return executeRequest(requestOptions);
  };

  return {
    getStoresByTenant,
  };
};
